<template>
<section class="fancy">
	<div class="container">
		<div class="upgrade-box">
			<!-- <p class="mb" v-if="this.user.token.groups.includes('/Basic') || this.user.token.groups.includes('/Bronze') || this.user.token.groups.includes('/Silver') || this.user.token.groups.includes('/Gold')">
				You will have access to DEIOS, once we have launched<span v-if="getAppendix()" v-html="getAppendix()"></span>.
			</p> -->

			<div v-if="this.user.token.groups.includes('/Preorder')">
				<div class="title mb2">
					Upgrade now and get 1 year (12 months) content subscription:
					<span v-if="getProduct() !== null" class="fs_price">
						<span v-bind:data-fsc-item-path="getProduct()" data-fsc-item-price></span>
					</span><br />
					<span class="small">- Subscription activates at launch.</span>
				</div>
				<div class="text-center mt2">
					<a v-on:click="fs()" class="button-sub button-xlg">Upgrade now</a>
				</div>
			</div>
			<div v-else>
				<div class="title mb2">
					Upgrade now
					<span v-if="getProduct() !== null" class="fs_price">
						Special OFFER: <span v-bind:data-fsc-item-path="getProduct()" data-fsc-item-price></span>
					</span><br />
					+ Standalone App <span class="small">(run DEIOS without subscription)</span>
				</div>
				<p v-if="this.user.token.groups.includes('/Kickstarter') && !this.user.token.groups.includes('/Gold PLUS')">
					Do you want to get a standalone key for DEIOS once it has launched? Upgrade now and you will receive a standalone key to continue using the software after your premium subscription has ended.
				</p>
				<p v-if="this.user.token.groups.includes('/Kickstarter') && this.user.token.groups.includes('/Gold PLUS')">
					Upgrade now and you will receive a <strong>standalone key</strong> to continue using the software after your premium subscription has ended.
				</p>
				<div class="text-center mt2">
					<a v-on:click="fs()" class="button-sub button-xlg">Upgrade now</a>
				</div>
			</div>

		</div>
	</div>
</section>
</template>

<script>
export default {
	name: 'SectionUpgradeBox',
	props: {
		user: Object,
	},
	methods: {

		getProduct() {
			let product = null;

			if (
				typeof this.user.token.dungeonfog === 'undefined' ||
				typeof this.user.token.dungeonfog.standalone_keys === 'undefined'
			) {
				if (this.user.token.groups.includes('/Gold PLUS')) {
					product = 'deios-upgrade-gold-plus';
				}
				if (this.user.token.groups.includes('/Gold')) {
					product = 'deios-upgrade-gold';
				}
				if (this.user.token.groups.includes('/Silver')) {
					product = 'deios-upgrade-silver';
				}
				if (this.user.token.groups.includes('/Bronze')) {
					product = 'deios-upgrade-bronze';
				}
				if (this.user.token.groups.includes('/Basic')) {
					product = 'deios-upgrade-basic';
				}
			}

			if (this.user.token.groups.includes('/Preorder')) {
				product = 'application-1y-upgrade';
			}

			return product;
		},

		fs() {
			let product = this.getProduct();
			if (product !== null) {
				window.fastspring.builder.reset();
				window.fastspring.builder.add(product);
				window.fastspring.builder.tag({
					'deiosUserId': this.user.token.sub
				});

				// // needs a fs secure payload
				// if (product === 'application-1y-upgrade') {
				// 	window.fastspring.builder.secure({
				// 		"contact": {
				// 			"email": null,
				// 			"firstName": null,
				// 			"lastName": null
				// 		},
				// 		"account": "fEbe8lNbQaCKUWfOlQMcEQ",
				// 	}, '');
				// }

				window.fastspring.builder.checkout();
			}
			return false;
		},

		getAppendix() {
			if (this.user.token.groups.includes('/Gold')) {
				return ' the <strong>Second ALPHA</strong>';
			}
			if (this.user.token.groups.includes('/Silver')) {
				return ' the <strong>Closed BETA</strong>';
			}
			if (this.user.token.groups.includes('/Bronze')) {
				return ' the <strong>Open BETA</strong>';
			}
			return false;
		}
	},
	// updated() {
	// 	window.fastspring.builder.updateSession()
	// },
	// mounted() {
	// 	window.fastspring.builder.updateSession()
	// }
}
</script>
